import { Box, Button, IconButton, Grid, Stack, Link } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from "@mui/icons-material/Close";
import "../vehicleCategories/vehicleCategories.css";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import { useEffect, useState } from "react";
import { transformationActions } from "../../service/transformation.action";
import { useTranslation } from "react-i18next";

const UploadSuccessModal: any = (props: any) => {
  const closeModal = props.closeModal;
  const { t } = useTranslation(["operation"]);

  const cancel = () => {
    closeModal(false);
  };

  return (
    <Box>
      <Dialog
        PaperProps={{
          sx: {
            maxWidth: "600px",
            minHeight: "214px",
          },
        }}
        open={true}
        aria-labelledby="draggable-dialog-title"
        maxWidth={"md"}
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          <Grid container alignItems="center" direction="row" spacing={2}>
            <Grid item sx={{ display: "flex" }}>
              <CheckCircleIcon sx={{ color: "green" }} />
            </Grid>

            <Grid xs item>
              <span className="titleUploadModa">
                {t(
                  "transportSupplierPriceList.uploadSuccessModal.priceListTitle"
                )}
              </span>
            </Grid>
            <Grid item sx={{ justifyContent: "flex-end", display: "flex" }}>
              <IconButton className="cancelIconClass">
                <CloseIcon onClick={cancel} />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent dividers>
          <Box className="contentUploadModalClass">
            {t("transportSupplierPriceList.uploadSuccessModal.priceListBody")}
          </Box>
        </DialogContent>
        <DialogActions className="footerUploadModelClass">
          <Grid
            container
            alignItems="center"
            alignContent="center"
            direction="row"
          >
            <Grid>
              <Link
                href="/operation/suppliers/carriersPriceImportTracking"
                className="linkUploadClass"
              >
                {t(
                  "transportSupplierPriceList.uploadSuccessModal.navigateMessage"
                )}
              </Link>
            </Grid>
            <Grid
              xs
              item
              sx={{ display: "flex", justifyContent: "flex-end" }}
              pr={2}
            >
              <Stack direction="row" spacing={2.5}>
                <Button
                  variant="contained"
                  onClick={cancel}
                  className="closeButtUploadClass"
                >
                  <span className="confirnTextClass">
                    {t("actionButtons.close")}
                  </span>
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </Box>
  );
};
export default UploadSuccessModal;
